module.exports = __webpack_public_path__ + "static/img/5-z3.c988d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/5-z3.png
// module id = 670
// module chunks = 140